import { css, keyframes, styled } from 'styles';
import { StyledCardProgressProps } from './types';

const absoluteStyles = css`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

const kfProgressBar = keyframes`
  0% {
    transform: scaleX(1) translateX(-100%);
  }
  50% {
    transform: scaleX(1) translateX(0%);
  }
  75% {
    animation-timing-function: cubic-bezier(.28, .62, .37, .91);
    transform: scaleX(1) translateX(0%);
  }
  100% {
    transform: scaleX(0) translateX(0%);
  }
`;

const kfProgressSplitter = keyframes`
  0% {
    transform: scaleX(.75) translateX(-125%);
  }
  30% {
    animation-timing-function: cubic-bezier(.42, 0, .6, .8);
    transform: scaleX(.75) translateX(-125%);
  }
  90% {
    transform: scaleX(.75) translateX(125%);
  }
  100% {
    transform: scaleX(.75) translateX(125%);
  }
`;

export const CardProgressBar = styled.div`
  ${absoluteStyles};

  animation: ${kfProgressBar} 1.5s linear infinite;
  background-color: ${({ theme }) => theme.card.progress.color};
  transform: scaleX(0);
  transform-origin: right center;
  will-change: transform;

  &:after {
    ${absoluteStyles};

    animation: ${kfProgressSplitter} 1.5s linear infinite;
    background-color: ${({ theme }) => theme.card.progress.background};
    content: '';
    transform-origin: center center;
  }
`;

export const StyledCardProgress = styled.div<StyledCardProgressProps>`
  height: 0.15rem;
  overflow: hidden;
  position: relative;
  visibility: ${({ $active }) => ($active ? 'visible' : 'hidden')};

  &:after {
    background-color: ${({ theme }) => theme.card.progress.background};
  }
`;

CardProgressBar.displayName = 'CardProgressBar';
StyledCardProgress.displayName = 'CardProgress';
